var map = {
	"./comprehension_locked.svg": 88,
	"./evennumbers_locked.svg": 89,
	"./letterjumble_locked.svg": 90,
	"./lettermixup_locked.svg": 91,
	"./numbersearch_locked.svg": 92,
	"./numbersinput_locked.svg": 93,
	"./numberswarmup_locked.svg": 94,
	"./powerreader_locked.svg": 95,
	"./schulteletters_locked.svg": 96,
	"./schultemix_locked.svg": 97,
	"./schultenumbers_locked.svg": 98,
	"./sentencesinput_locked.svg": 99,
	"./sentenceswarmup_locked.svg": 100,
	"./textsearch_locked.svg": 101,
	"./wordpairs_locked.svg": 102,
	"./wordsearch_locked.svg": 103,
	"./wordsinput_locked.svg": 104,
	"./wordswarmup_locked.svg": 105,
	"./wpmtest_locked.svg": 106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;